import React, { useState } from 'react';
import { Modal, Form, Input, Button, Alert } from 'antd';
import { isUUID } from 'validator';

const RequestTracerSearchModal = ({ visible, onCancel, onSearch, loading }) => {
  const [form] = Form.useForm();
  const [formErrors, setFormErrors] = useState({});

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (!values.traceId || !values.adId) return; // Defensive check
        setFormErrors({});
        onSearch(values.traceId, values.adId);
      })
      .catch(() => {});
  };

  const validateFields = (rule, value, callback) => {
    if (rule.field === 'traceId' && !value) {
      callback('Trace ID cannot be empty');
    } else if (rule.field === 'adId' && value && !isUUID(value)) {
      callback('Invalid UUID format');
    } else {
      callback();
    }
  };

  return (
    <Modal
      title="Find Trace"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="search" type="primary" onClick={handleOk} loading={loading}>
          Search
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Trace ID" name="traceId" rules={[{ required: true, message: 'Trace ID cannot be empty' }]}>
          <Input placeholder="Enter Trace ID" autoFocus />
        </Form.Item>
        <Form.Item
          label="Ad ID"
          name="adId"
          rules={[{ required: true, message: 'Ad ID cannot be empty' }, { validator: validateFields }]}
        >
          <Input placeholder="Enter Ad ID (UUID)" />
        </Form.Item>
        {formErrors.global && <Alert type="error" message={formErrors.global} showIcon />}
      </Form>
    </Modal>
  );
};

export default RequestTracerSearchModal;
